function mapGetOneAgencyLocationData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListAgencyLocationsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneAgencyLocationData, mapGetListAgencyLocationsData };
